import type { ApiErrorBody, ApiErrorSeverity } from "@/types/common";

const SEVERIDADES: ReadonlySet<ApiErrorSeverity> = new Set(["error", "warning", "info"]);

export function isApiErrorBody(valor: unknown): valor is ApiErrorBody {
	if (typeof valor !== "object" || valor === null) return false;
	const obj = valor as Record<string, unknown>;
	if (typeof obj.message !== "string" || obj.message.trim() === "") return false;
	if (obj.severity !== undefined && !SEVERIDADES.has(obj.severity as ApiErrorSeverity)) return false;
	return true;
}

/** Lê e valida `{ message, severity?, code? }` de uma resposta de erro, sem consumir o body original. */
export async function lerCorpoErroApi(response: Response | undefined): Promise<ApiErrorBody | undefined> {
	if (!response) return undefined;
	try {
		const dados: unknown = await response.clone().json();
		return isApiErrorBody(dados) ? dados : undefined;
	} catch {
		return undefined;
	}
}

// Guarda o corpo já parseado associado à instância do erro, sem poluir o objeto de erro.
const corpoErroPorErro = new WeakMap<object, ApiErrorBody>();

export function anexarErroApi(err: object, corpo: ApiErrorBody): void {
	corpoErroPorErro.set(err, corpo);
}

export function obterErroApi(err: unknown): ApiErrorBody | undefined {
	return typeof err === "object" && err !== null ? corpoErroPorErro.get(err) : undefined;
}

/**
 * Mensagem exibível de um erro: a do envelope da API quando houver, senão a do próprio `Error`,
 * senão o texto de fallback da tela.
 */
export function obterMensagemErroApi(err: unknown, fallback: string): string {
	return obterErroApi(err)?.message ?? (err instanceof Error ? err.message : fallback);
}
